
import { useState, useEffect } from "react";
import { useToast } from "@/hooks/use-toast";
import { HiringStage } from "@/lib/types";
import { staffStages as initialStaffStages } from "@/components/staff/data";

export function useStaffProgress() {
  const { toast } = useToast();
  const [currentStage, setCurrentStage] = useState(0);
  const [progress, setProgress] = useState(0);
  const [staffStages, setStaffStages] = useState<HiringStage[]>(initialStaffStages);
  const [selectedCandidate, setSelectedCandidate] = useState<number | null>(null);

  useEffect(() => {
    setProgress(((currentStage) / (staffStages.length - 1)) * 100);
  }, [currentStage, staffStages.length]);

  const handleNextStage = () => {
    if (currentStage < staffStages.length - 1) {
      if (currentStage === 0 && selectedCandidate === null) {
        toast({
          title: "Selection required",
          description: "Please select an AI assistant to continue.",
          variant: "destructive",
        });
        return;
      }
      
      const updatedStages = [...staffStages];
      updatedStages[currentStage].isCompleted = true;
      setStaffStages(updatedStages);
      
      setCurrentStage(currentStage + 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handlePreviousStage = () => {
    if (currentStage > 0) {
      setCurrentStage(currentStage - 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return {
    currentStage,
    progress,
    staffStages,
    selectedCandidate,
    setSelectedCandidate,
    handleNextStage,
    handlePreviousStage
  };
}
